import React, { Component } from 'react';
import WOW from 'wowjs';
import Header from './components/header/header';
import About from './components/about/about';
import Resume from './components/resume/resume';
import Footer from './components/footer/footer';
import resumeData from './resumeData';
class App extends Component {
  // init for WOWjs
  componentDidMount(){
    new WOW.WOW().init();
  }
  render() {
    return (
      <div className="App">
        <Header resumeData={resumeData}/>
        <About resumeData={resumeData}/>
        <Resume resumeData={resumeData}/>
        <Footer resumeData={resumeData}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js